import React from 'react';
import logoEurope from '../../static/images/logos/europe.jpg';
import logoVilleBruxelles from '../../static/images/logos/ville-bruxelles.png';
import logoFrancophonie from '../../static/images/logos/francophonie.jpg';
import logoCocof from '../../static/images/logos/cocof.png';

export const Footer = () => (
  <footer className="footer w-full md:w-10/12 m-auto">
    <p className="p-8 flex flex-wrap items-center justify-between">
      <img src={logoEurope} className="w-24" alt="union européenne" />
      <a href="https://www.francophonie.org/"><img src={logoVilleBruxelles} alt="organisation internationale de la francophonie" className="w-32" /></a>
      <a href="https://ccf.brussels/"><img src={logoCocof} alt="cocof" className="w-32" /></a>
      <a href="https://www.bruxelles.be/"><img src={logoFrancophonie} alt="ville de bruxelles" className="w-32" /></a>
    </p>
    <div className="flex flex-col md:flex-row px-8 flex ">

      <div className="w-full md:w-1/4">

        <h3>
          PARTENAIRES
        </h3>
        <ul className="pr-8">
          <li>DEI Belgique</li>
          <li>FEDASIL</li>
          <li>Croix-Rouge Belgique</li>
        </ul>
      </div>
      <div className="w-full md:w-3/4">
        <h3>SOUTIENS</h3>
        <ul>
          <li>Ce projet est financé par le Programme Droits, égalité et citoyenneté de l'Union européenne (2014-2020).</li>
          <li>Avec le soutien de l'Organisation Internationale de la francophonie,</li>
          <li>de la Ville de Bruxelles – Solidarité internationale</li>
          <li>et de la COCOF (FIPI et Éducation permanente) </li>
        </ul>
      </div>

    </div>
    <p className="mt-4 px-8">
      © Défense des Enfants International Belgique
      <br />
      Projet BRIDGE : Lutte contre la violence basée sur le genre envers les enfants et les jeunes migrant
    </p>
  </footer>
);
